import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalRestaurantEmployeesDocument = gql`
  query SalesPortalRestaurantEmployees(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getRestaurantEmployees(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      chat_employee_id
      employee_contact_email
      employee_contact_phone_number
      employee_id
      employee_login_email
      employee_name
      employee_status
      restaurant_employee_id
      restaurant_employee_role
      show_app_payments_tab
    }
  }
`;
export function useSalesPortalRestaurantEmployeesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >(SalesPortalRestaurantEmployeesDocument, options);
}
export function useSalesPortalRestaurantEmployeesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >(SalesPortalRestaurantEmployeesDocument, options);
}
export type SalesPortalRestaurantEmployeesQueryHookResult = ReturnType<
  typeof useSalesPortalRestaurantEmployeesQuery
>;
export type SalesPortalRestaurantEmployeesLazyQueryHookResult = ReturnType<
  typeof useSalesPortalRestaurantEmployeesLazyQuery
>;
export type SalesPortalRestaurantEmployeesQueryResult = Apollo.QueryResult<
  Types.SalesPortalRestaurantEmployeesQuery,
  Types.SalesPortalRestaurantEmployeesQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalRestaurantEmployeesQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalRestaurantEmployeesQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >(SalesPortalRestaurantEmployeesDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalRestaurantEmployeesLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalRestaurantEmployeesLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalRestaurantEmployeesQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalRestaurantEmployeesQuery,
    Types.SalesPortalRestaurantEmployeesQueryVariables
  >(SalesPortalRestaurantEmployeesDocument, lazyOptions);
}
